import { gql } from 'apollo-boost';

export const campaignsSuggest = gql`
    query CampaignsSuggestQuery($login: String!, $campaignInput: GdCampaignsContainerInput!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            campaigns(input: $campaignInput) {
                rowset {
                    name
                }
            }
        }
    }
`;

export const campaignsSuggestList = gql`
    query CampaignsSuggestListQuery($login: String!, $campaignInput: GdCampaignsContainerInput!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            campaigns(input: $campaignInput) {
                rowset {
                    name
                    id
                    type
                    strategy {
                        isAutoBudget
                    }
                    ... on GdInternalFreeCampaignTruncated {
                        adsCount
                    }
                    ... on GdInternalDistribCampaignTruncated {
                        adsCount
                    }
                }
            }
        }
    }
`;

export const groupsSuggest = gql`
    query GroupsSuggestQuery($login: String!, $adGroupInput: GdAdGroupsContainerInput!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            adGroups(input: $adGroupInput) {
                rowset {
                    name
                }
            }
        }
    }
`;

export const groupsSuggestList = gql`
    query GroupsSuggestListQuery($login: String!, $adGroupInput: GdAdGroupsContainerInput!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            adGroups(input: $adGroupInput) {
                rowset {
                    id
                    adsCount
                    name
                    access {
                        canEdit
                    }
                    status {
                        primaryStatus
                    }
                    minusKeywords
                    regionsInfo {
                        regionIds
                    }
                    campaign {
                        type
                    }
                    type
                }
            }
        }
    }
`;

export const bannersSuggest = gql`
    query BannersSuggestQuery($login: String!, $adsInput: GdAdsContainerInput!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            ads(input: $adsInput) {
                rowset {
                    title
                }
                cacheKey
            }
        }
    }
`;

export const phrasesSuggest = gql`
    query PhrasesSuggestQuery($login: String!, $showConditionsInput: GdShowConditionsContainerInput!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            showConditions(input: $showConditionsInput) {
                rowset {
                    ... on GdKeyword {
                        keyword
                    }
                }
                cacheKey
            }
        }
    }
`;

export const retargetingsSuggest = gql`
    query RetargetingsSuggestQuery($login: String!, $retargetingsInput: GdRetargetingsContainerInput!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            retargetings(input: $retargetingsInput) {
                rowset {
                    retargetingId
                    retargetingCondition {
                        name
                    }
                }
            }
        }
    }
`;

export const feedFiltersSuggest = gql`
    query FeedFiltersSuggestQuery($login: String!, $smartFiltersInput: GdSmartFiltersContainerInput!) {
        reqId: getReqId
        client(searchBy: { login: $login }) {
            smartFilters(input: $smartFiltersInput) {
                rowset {
                    id
                    name
                }
            }
        }
    }
`;
